import OriginTypography from './typography';
import Title from './title';
import Text from './text';
import Paragraph from './paragraph';
var Typography = OriginTypography;
Typography.Title = Title;
Typography.Text = Text;
Typography.Paragraph = Paragraph;
export default Typography;
